<template>    
  <div class="background_basic">            
    <v-card class="ma-3">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="grey--text text--darken-3">
          <v-icon class="mr-2">mdi-access-point</v-icon>LED
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn color="blue" text @click="initialize()" class="font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">refresh</v-icon>초기화
        </v-btn>
        <v-btn color="blue" text @click="ExcelExpert('LED')" class = "ml-2 font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">mdi-microsoft-excel</v-icon>엑셀
        </v-btn>
        <v-spacer></v-spacer>

        <v-btn color="blue" text :disabled="!ProgramPermissionInfo.okC" @click="ClearDialog()" class="font-weight-bold text-subtitle-1">
          <v-icon big class="mr-2">post_add</v-icon>신규등록
        </v-btn>
        
      </v-toolbar>      

      <v-divider></v-divider>
    
      <v-card flat class="d-flex ml-3 mr-3">                
        <v-text-field
          v-model="cNowSearchKeyWord"
          class="ml-3 mb-n5"
          label="검색어"
          placeholder="LED ID or Sensor Mac 입력"
          persistent-placeholder
          style="max-width:250px;"
          Regular
          v-on:keyup.enter="Search()"
        ></v-text-field>
        
        <v-btn icon class="ml-n8 mt-3 text-subtitle-1" @click="Search()">
          <v-icon>search</v-icon>
        </v-btn>
      </v-card>    
      <v-divider></v-divider>

      <v-data-table         
        :items-per-page="15" 
        fixed-header 
        height="calc(100vh - 247px)" 
        :headers="headers" 
        :items="Records"
        @dblclick:row="handleDoubleClick">
        <template v-slot:item.action="{ item }">          
          <v-icon big class="mr-0" @click="editItem(item)" :disabled="!ProgramPermissionInfo.okU">edit</v-icon>
          <v-icon big @click="deleteItem(item)" :disabled="!ProgramPermissionInfo.okD">delete</v-icon>
        </template>
        
        <template v-slot:item.cUse="{ item }">
          <v-chip v-if="item.cUse == 'Y' " small label color="grey lighten-3">사용</v-chip>
          <v-chip v-else small color="grey darken-3" label dark>미사용</v-chip>
        </template> 
        
        <template v-slot:no-data>
          <p>No data available.</p>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="600px">          
      <v-card ref="form">
        <v-card-title >
          <span class="font-weight-bold">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row class="ma-0">
              <v-col cols="12" sm="6" md="6">
                <v-text-field dense v-model="editedItem.cLED_Id" label="Id" :disabled="isEditMode" maxlength="20" hint="필수항목" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId1" label="Sensor1" maxlength="50" hint="필수항목" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId2" label="Sensor2" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId3" label="Sensor3" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId4" label="Sensor4" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId5" label="Sensor5" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId6" label="Sensor6" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId7" label="Sensor7" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId8" label="Sensor8" maxlength="50" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" >
                <v-text-field dense v-model="editedItem.cSensorId9" label="Sensor9" maxlength="50" persistent-hint></v-text-field>
              </v-col>

              <v-col cols="12" sm="12" md="12" >
                <v-text-field dense v-model="editedItem.cLine1" label="1행" maxlength="16" hint="(한글 8자,영문 숫자 16자)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" >
                <v-text-field dense v-model="editedItem.cLine2" label="2행" maxlength="16" hint="(한글 8자,영문 숫자 16자)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" >
                <v-text-field dense v-model="editedItem.cLine3" label="3행" maxlength="16" hint="(한글 8자,영문 숫자 16자)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" >
                <v-text-field dense v-model="editedItem.cLine4" label="4행" maxlength="16" hint="(한글 8자,영문 숫자 16자)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12" >
                <v-text-field dense v-model="editedItem.cLine5" label="5행" maxlength="16" hint="(한글 8자,영문 숫자 16자)" persistent-hint></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select dense v-model="editedItem.cUse" label="사용여부" :items="zUse"  item-value="sId" item-text="sNm"></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>                
          <v-spacer></v-spacer>
          <v-btn color="blue darken-2" text @click="save" :disabled="loading" class="font-weight-bold text-subtitle-1">
            <v-icon big class="mr-2">save</v-icon>저장
          </v-btn>
          <v-btn color="grey darken-2" text @click="close" :disabled="loading" class="font-weight-bold text-subtitle-1">
            <v-icon big class="mr-2">cancel</v-icon>취소
          </v-btn>
        </v-card-actions>              
        <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom color="blue accent-4"></v-progress-linear>
      </v-card>
    </v-dialog>
    <MsgBox ref="MsgBoxRef" @onMsgBox="onMsgBoxFunc" />    
  </div>
</template>

<script>
import EventBus from '@/eventBus.js';
import axios from "axios";
import { mapState } from "vuex";
import XLSX from 'xlsx';
import BasicInfo from "../BasicInfo.js";
import MsgBox from "../components/MsgBox.vue";
import router from "../router";
import Util from "../Util.js";


export default {
  components: {
    MsgBox,
  },
  data: () => ({
    bReadFile : false,
    cNowSearchKeyWord : "",
    cNowCheck: "A",
    loading : false,
    loading2 : false,
    isEditMode : false,
    iDelIndex: 0,
    dialog: false,    
    FileRecords : [],
    Fileheaders: [      
      { class: "font-weight-bold subtitle-2", text: "Id", value: "cLED_Id", align: "center" },      
      { class: "font-weight-bold subtitle-2", text: "Mac1", value: "cSensorId1", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac2", value: "cSensorId2", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac3", value: "cSensorId3", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac4", value: "cSensorId4", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac5", value: "cSensorId5", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac6", value: "cSensorId6", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac7", value: "cSensorId7", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac8", value: "cSensorId8", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac9", value: "cSensorId9", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Type", value: "cType", align: "center" },      
      { class: "font-weight-bold subtitle-2", text: "IP", value: "cIp", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "Port", value: "cPort", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "InOut", value: "cInOut", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "Server", value: "cServer", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "PowerId", value: "cPowerId", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "LimitRSSI", value: "cLimitRSSI", align: "center", },
      { class: "font-weight-bold subtitle-2", text: "Count", value: "cCount", align: "center",},
      { class: "font-weight-bold subtitle-2", text: "사용여부", value: "cUse", align: "center",},
    ],  
    headers: [      
      { class: "font-weight-bold subtitle-2", text: "Id", value: "cLED_Id", align: "center" },      
      { class: "font-weight-bold subtitle-2", text: "Mac1", value: "cSensorId1", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "Mac2", value: "cSensorId2", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "Mac3", value: "cSensorId3", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "Mac4", value: "cSensorId4", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac5", value: "cSensorId5", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac6", value: "cSensorId6", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac7", value: "cSensorId7", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac8", value: "cSensorId8", align: "center"},
      { class: "font-weight-bold subtitle-2", text: "Mac9", value: "cSensorId9", align: "center"},      
      { class: "font-weight-bold subtitle-2", text: "1행", value: "cLine1", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "2행", value: "cLine2", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "3행", value: "cLine3", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "4행", value: "cLine4", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "5행", value: "cLine5", align: "center", width:150},
      
      { class: "font-weight-bold subtitle-2", text: "등록일", value: "cCreateDateTime", align: "center", width:150},
      { class: "font-weight-bold subtitle-2", text: "사용여부", value: "cUse", align: "center" },      
      { class: "font-weight-bold subtitle-2", text: "작업", value: "action", align: "center", sortable: false, width:130},      
      
    ],
    Records: [],
    editedIndex: -1,
    // userId(스토어), cDel(golang), cEtc(golang)만 제외하고 테이블의 항목을 설정함 
    editedItem: { 
      cSensorId1: "",      
      cSensorId2: "",      
      cSensorId3: "",      
      cSensorId4: "",      
      cSensorId5: "",      
      cSensorId6: "",      
      cSensorId7: "",      
      cSensorId8: "",      
      cSensorId9: "",            
      cUse: "Y",      
      cDel: "N",
      cLine1 : "",
      cLine2 : "",
      cLine3 : "",
      cLine4 : "",
      cLine5 : "",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    },
    deletedItem: {
      cSensorId: "",      
      cUse: "Y",      
      cDel: "N",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    },
    defaultItem: {
      cSensorId1: "",      
      cSensorId2: "",      
      cSensorId3: "",      
      cSensorId4: "",      
      cSensorId5: "",      
      cSensorId6: "",      
      cSensorId7: "",      
      cSensorId8: "",      
      cSensorId9: "",      
      cUse: "Y",      
      cDel: "N",
      cLine1 : "",
      cLine2 : "",
      cLine3 : "",
      cLine4 : "",
      cLine5 : "",
      cCreateDateTime: "",
      cUpdateDateTime: "",
    }
  }),

  computed: {
    ...mapState(["UserInfo", "ProgramPermissionInfo", "zUse", "zMappingAll", "zDeviceType", "zApState", "zApInOutType"]),
    formTitle() {
      return this.editedIndex === -1 ? "신규 등록" : "항목 수정";
    },
  },

  mounted() {
    this.initialize();
  },

  methods: {    
    initialize() {
      this.cNowSearchKeyWord = "";
      this.cNowCheck= "A",
      this.Search();    
    },
    

    ClearDialog() {      
      this.isEditMode = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.dialog = true;           
    },


    goApInfoPage(){
      router.push({name: "APInfo"});
    },

    handleDoubleClick(value, items) { 
       if (!this.ProgramPermissionInfo.okU) return;
       this.editItem(items.item);  
    },

    Search() {
      this.Records = [];
      var posData = {        
        cNowSearchKeyWord : this.cNowSearchKeyWord,
      };
      axios
        .post(BasicInfo.UIL_API + "GetLED_Info", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {
            this.Records = res.data.Result;            
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },


    isValidLength(input) {
      let length = 0;

      for (let char of input) {
          if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(char)) {
              length += 2; // 한글은 2자로 계산
          } else {
              length += 1; // 영문 및 숫자는 1자로 계산
          }

          if (length > 16) return false; // 16자를 초과하면 즉시 false 반환
      }

      return true;
    },

    save() {
      if (this.editedItem.cLED_Id == "" ) {
        EventBus.$emit("onShowMsg",true, "LED ID는 필수입력 항목입니다.");
        return;
      }

      if (this.editedItem.cSensorId1 == "" ) {
        EventBus.$emit("onShowMsg",true, "Sensor MAC1은 필수입력 항목입니다.");
        return;
      }


      if (!this.isValidLength(this.editedItem.cLine1)) {
        EventBus.$emit("onShowMsg",true, "1행이 '한글 8자,영문 숫자 16자'를 초과합니다. 입력을 확인하세요.");
        return;
      }
      if (!this.isValidLength(this.editedItem.cLine2)) {
        EventBus.$emit("onShowMsg",true, "2행이 '한글 8자,영문 숫자 16자'를 초과합니다. 입력을 확인하세요.");
        return;
      }
      if (!this.isValidLength(this.editedItem.cLine3)) {
        EventBus.$emit("onShowMsg",true, "3행이 '한글 8자,영문 숫자 16자'를 초과합니다. 입력을 확인하세요.");
        return;
      }
      if (!this.isValidLength(this.editedItem.cLine4)) {
        EventBus.$emit("onShowMsg",true, "4행이 '한글 8자,영문 숫자 16자'를 초과합니다. 입력을 확인하세요.");
        return;
      }
      if (!this.isValidLength(this.editedItem.cLine5)) {
        EventBus.$emit("onShowMsg",true, "5행이 '한글 8자,영문 숫자 16자'를 초과합니다. 입력을 확인하세요.");
        return;
      }
      
      var posData = {
        cUserId: this.$store.state.UserInfo.UserId,
        cLED_Id: this.editedItem.cLED_Id,
        cSensorId1: this.editedItem.cSensorId1,
        cSensorId2: this.editedItem.cSensorId2,
        cSensorId3: this.editedItem.cSensorId3,
        cSensorId4: this.editedItem.cSensorId4,
        cSensorId5: this.editedItem.cSensorId5,
        cSensorId6: this.editedItem.cSensorId6,
        cSensorId7: this.editedItem.cSensorId7,
        cSensorId8: this.editedItem.cSensorId8,
        cSensorId9: this.editedItem.cSensorId9,
        cLine1: this.editedItem.cLine1,
        cLine2: this.editedItem.cLine2,
        cLine3: this.editedItem.cLine3,
        cLine4: this.editedItem.cLine4,
        cLine5: this.editedItem.cLine5,
        cUse: this.editedItem.cUse,
        cDel: this.editedItem.cDel,
      }

      
      this.loading = true;
      axios
        .post(BasicInfo.UIL_API + "SetLED_Info", posData, {
          headers: {
            Authorization: this.$store.state.UserInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
          if (res.data.ResultCd === "00") {
            if (this.isEditMode) {              
              this.editedItem.cUpdateDateTime = res.data.Result[0].cUpdateDateTime;
              Object.assign(this.Records[this.editedIndex], this.editedItem);
            } else {              
              this.editedItem.cCreateDateTime = res.data.Result[0].cUpdateDateTime;
              this.editedItem.cUpdateDateTime = res.data.Result[0].cUpdateDateTime;                            
              this.Records.push(this.editedItem);
            }
            this.dialog = false;
            EventBus.$emit("onShowMsg",false, "저장되었습니다.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
          this.loading = false;
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
          this.loading = false;
        });
    },
    
    
    close() {      
      this.dialog = false;
      this.isEditMode = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    
    editItem(item) {
      this.isEditMode = true;
      this.editedIndex = this.Records.indexOf(item);   
      this.editedItem = Object.assign({}, item);       
      this.dialog = true;
    },

    
    deleteItem(item) {
      this.iDelIndex = this.Records.indexOf(item);
      this.deletedItem = Object.assign({}, item);
      this.$refs.MsgBoxRef.RunMsgBoxShow(
        "확인",
        "삭제하시겠습니까? \r\n 삭제하시면 복원되지 않습니다. \r\n[" +
          this.deletedItem.cLED_Id +
          "]"
      );
    },

    
    onMsgBoxFunc: function(result) {
      if (result === true) {
        //삭제
        var posData = {
          cUserId: this.$store.state.UserInfo.UserId,
          cLED_Id: this.deletedItem.cLED_Id,
        };
        axios
          .post(BasicInfo.UIL_API + "DelLED_Info", posData, {
            headers: {
              Authorization: this.$store.state.UserInfo.Token
            }
          })
          .then(res => {
            if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          
            if (res.data.ResultCd === "00") {
              this.Records.splice(this.iDelIndex, 1); 
              EventBus.$emit("onShowMsg",false, "삭제되었습니다.");
            } else {
              EventBus.$emit("onShowMsg",true, res.data.Msg);
            }
          })
          .catch(err => {
            EventBus.$emit("onShowMsg",true, ""+err);
          });
      }
    },

    
    ExcelExpert(name){
      var r = Util.GetExcel(this.Records, this.headers);
      var animalWS = XLSX.utils.json_to_sheet(r)       
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, animalWS, name) // sheetAName is name of Worksheet      
      XLSX.writeFile(wb, name + "-" + Util.sNowDate() + '.xlsx'); // name of the file is 'book.xlsx'
    },
  }
};
</script>

